import Vue from 'vue'
import Vuex from "vuex";

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        userData: {},
        manufactorer: null,
        model: null,
        engine: null,
        currentTableRow: null,
        exlsWorks: [],
        googleAttrs: [],
        fixedTitles: [],
        apiWorks: [],
        selectedExlsWorks: [],
        currentStep: 1,
        maxAvailableStep: 1,
        activeKeyPopup: 1,
        selected_date: null,
        selected_time: null,
        cartPopupIsOpened: false
    },
    mutations: {
        initializeState(state) {
            if (localStorage.getItem('state')) {
                this.replaceState(
                    Object.assign(state, JSON.parse(localStorage.getItem('state')))
                )
                state.cartPopupIsOpened = false;
            }
        },
        /**
         * 
         * @param {*} state 
         * @param {*} params 
         */
        updateValue(state, params) {
            if (params.target == "manufactorer") {
                state.model = state.engine = null
            }
            if (params.target == "model") {
                state.engine = null
            }
            state[params.target] = params.value;
        },
        deleteSelectedWork(state, params) {
            console.log(params);
            if(Number(params.row.id)){
                state.apiWorks.splice((params.$index - state.selectedExlsWorks.length), 1)
            } else{
                state.selectedExlsWorks.splice(params.$index, 1)
            }
        },
        setStep(state, step) {
            state.maxAvailableStep = step > state.currentStep ? step : state.maxAvailableStep;
            state.currentStep = step;
        },
        setXlsxWorksList(state, list) {
            state.exlsWorks = list
        },
        setFromGoogleDocs(state, list) {
            state.googleAttrs = list.resultArray
            state.fixedTitles = list.fixedTitles
        },
        restoreDefault(state){
            Object.assign(state, {
                userData: {},

                engine: null,
                currentTableRow: null,
                apiWorks: [],
                selectedExlsWorks: [],
                currentStep: 1,
                maxAvailableStep: 1,
                activeKeyPopup: 1,
                selected_date: null,
                selected_time: null,
                cartPopupIsOpened: false
            })
        }
    },
    actions: {
        updateStateValue({ commit }, params) {
            return new Promise((resolve, reject) => {
                commit('updateValue', params)
                resolve()
            })

        },
        deleteSelectedWork({ commit }, params) {
            return new Promise((resolve, reject) => {
                commit('deleteSelectedWork', params)
                resolve()
            })
        },
        setStep({ commit }, step) {
            return new Promise((resolve, reject) => {
                commit('setStep', step)
                resolve()
            })
        },
        setXlsxWorksList({ commit }) {
            return new Promise((resolve, reject) => {
                fetch(`/wp-admin/admin-ajax.php?action=getWorksFromXlsx`, {
                    method: "POST",
                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        commit('setXlsxWorksList', response.data.xlsx_data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    });
            })

        },
        async setFromGoogleDocs({ commit }) {
            try {
                return new Promise((resolve, reject) => {
                    fetch(`/wp-admin/admin-ajax.php?action=getGoogleSpreadSheets`, {
                        method: "POST",
                    })
                        .then((response) => {
                            return response.json();
                        })
                        .then((response) => {
                            commit('setFromGoogleDocs', response.data.google_list)
                            return resolve(response.data.google_list)
                        })
                        .catch(() => {
                            reject()
                        });
                })
            } catch (e){
                throw e
            }

        },
        setWorks({ commit }, params) {
            return new Promise((resolve, reject) => {
                commit('updateValue', {
                    target: 'apiWorks',
                    value: params.api
                })            

                commit('updateValue', {
                    target: 'selectedExlsWorks',
                    value: params.xlsx
                })

                resolve();
            })
        },
        restoreDefault({commit}){
            commit('restoreDefault')
        }
    },
    getters: {
        getValue: state => key => {
            return state[key]
        },
        getActiveStepPopup(state, getters) {
            if(!getters.getBothSelectedWorks.length){
                state.selected_date = null;
                state.selected_time = null;
                return 1
            }
            return state.activeKeyPopup
        },
        getAvailableStep(state) {
            return state.maxAvailableStep
        },
        getActiveStep(state) {
            return state.currentStep
        },
        cartPrice(state, getters) {
            return getters.getBothSelectedWorks.reduce((a, b) => a += b.workPrice, 0).toFixed(1);
        },
        cartPopupIsOpened(state) {
            return state.cartPopupIsOpened
        },
        getApiList(state) {
            return state.apiWorks
        },
        getXlsxList(state) {
            return state.exlsWorks
        },
        getGoogleList(state){
            return state.googleAttrs
        },
        getFixedTitles(state){
            return state.fixedTitles
        },
        getSelectedExlsWorks(state) {
            return state.selectedExlsWorks
        },
        getBothSelectedWorks(state, getters) {
            return getters.getSelectedExlsWorks.concat(getters.getApiList)
        }
    }
})